import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  FaBriefcase,
  FaBuilding,
  FaCalculator,
  FaCalendarAlt,
  FaChalkboardTeacher,
  FaFolderOpen,
  FaHandshake,
  FaMoneyBill,
  FaPenSquare,
  FaPhotoVideo,
  FaRegStar,
  FaBirthdayCake,
  FaUserAlt,
  FaAddressCard,
  FaStar,
} from "react-icons/fa";
import { FaRegSnowflake } from "react-icons/fa";

import "flowbite/dist/flowbite.min.js";
import moment from "moment";

import { BACKEND } from "../config/configEnvs";
import AnunciosHomeContainer from "../components/inicio/AnunciosHomeContainer";
import { MdGroups } from "react-icons/md";
import DetailsButton from "../components/ui/components/DetailsButton";
import DrawerCotizacionDetails from "../components/ItemsTable/DrawerCotizacionDetails";
import HandleUpdateCheckbox from "../utils/HandleUpdateCheckbox";
import Modal from "../components/ui/Modal";
import PaginationItem from "../components/ui/components/Pagination";
import { GiReceiveMoney } from "react-icons/gi";
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen";
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen";
import { incrementNotifications, decrementNotifications, setNotifications } from "../features/notificationsSlice";
import DrawerCotizacionCalendarioPagosDetails from "../components/calendarioPagos/DrawerCotizacionCalendarioPagosDetails";

const Inicio = () => {

  const user = useSelector((state) => state.auth.user);
  const isAdmin = user.area.toUpperCase() === "ADMINISTRACION" || user.area.toUpperCase() === "COMERCIAL";

  const [anuncios, setAnuncios] = useState([]);

  const [birthdayWorkers, setBirthdayWorkers] = useState([]);
  const [pendingPaymentServices, setPendingPaymentServices] = useState([]);

  const [loading, setLoading] = useState(false);
  
  const [limit, setLimit] = useState(0);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalDocs, setTotalDocs] = useState(0);

  const [serviceData, setServiceData] = useState(null);

  const [brands, setBrands] = useState([]);

  const [openDrawer, setOpenDrawer] = useState(false);
  const [activeCotizacionData, setActiveCotizacionData] = useState(null);

  const [openModal, setOpenModal] = useState(false);

  const [currencyExchanges, setCurrencyExchanges] = useState({})
   
  const [paises, setPaises] = useState([]);

  const getPaises = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/paises?limit=0`);
      setPaises(response.data.docs);
    } catch (error) {
      console.error(error);
    }
  }

  const getCurrencyExchange = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/tiposCambio?limit=0`)
      const currencyExchanges = response.data.docs.reduce((acc, item) => {
        acc[item.moneda] = item.tipoCambio
        return acc
      }, {})
      setCurrencyExchanges(currencyExchanges)
    } catch (error) {
      return false
    }
  }

  const dispatch = useDispatch();

  const getWorkers = async () => { // Se obtienen los trabajadores y sus cumpleaños
    try {
      const response = await axios.get(`${BACKEND}/api/trabajadores?limit=0&where[activo][equals]=true`);
      const workers = response.data.docs;

      if (Array.isArray(workers)) {
        const sortedWorkers = workers
          .filter((worker) => worker.birthday)
          .map((worker) => {
            const birthday = moment(
              worker.birthday,
              "YYYY-MM-DDTHH:mm:ss.SSSZ"
            );

            const today = moment();
            birthday.year(today.year());
            // Si la fecha de cumpleaños ya pasó este año, calculamos para el próximo año
            if (today.isAfter(birthday) || today.isSame(birthday, "day")) {
              birthday.add(1, "year");
            }
            // Calcula los días restantes hasta el próximo cumpleaños
            const daysUntilBirthday = birthday.diff(today, "days");

            return {
              ...worker,
              daysUntilBirthday,
            };
          })
          .sort((a, b) => a.daysUntilBirthday - b.daysUntilBirthday);

        setBirthdayWorkers(sortedWorkers);
      } else {
        console.error(
          "La respuesta del servidor no es una matriz de trabajadores."
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchAnuncios = async () => { // Se obtienen los anuncions de administración
    try {
      const response = await axios.get(`${BACKEND}/api/anuncios`, {
        params: {
          limit: 15,
        },
      });
      setAnuncios(response.data.docs);
    } catch (error) {
      console.error(error);
    }
  };

  const getAdminData = async () => { // Se obtienen los datos de administración
    try {
      setLoading(true)
      //const response = await axios.get(`${BACKEND}/api/serviciosCotizaciones?limit=${limit}&page=${page}&where[estado][equals]=En proceso&where[facturacion][equals]=Deuda`);
      const response = await axios.get(`${BACKEND}/api/serviciosCotizaciones?limit=${limit}&page=${page}&where[estado][equals]=En proceso&where[facturacion][equals]=Deuda&where[porcentajeAvance][greater_than_equal]=50&depth=3`);

      setPendingPaymentServices(response.data.docs);
      setTotalDocs(response.data.totalDocs);
      setTotalPages(response.data.totalPages);
      dispatch(setNotifications(response.data.docs.filter((service) => service.statusReadByAdmin === false).length));
    } catch (error) {
      return false
    } finally {
      setLoading(false)
    }
  };

  const getBrands = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/marcas?limit=0&sort=createdAt`)
      setBrands(response.data.docs)
    } catch (e) {
      return false
    }
  }

  const handlePageChange = (event, value) => { // Cambiar la página
    setPage(value)
  }
  
  useEffect(() => {
    if (isAdmin) {  
      getAdminData()
      getBrands()
    } else {
      fetchAnuncios();
    }
    getPaises()
    getWorkers()
  }, []);

  useEffect(() => {
    if (isAdmin) {
      getAdminData()
    }
  }, [page, limit])

  const infoEnviada = {
    "Por confirmar": "text-yellow-400",
    "No envió nada": "text-red-500",
    "Envió poco": "text-green-500",
    "Envió todo": "text-blue-500"
  }

  const calculateAge = (birthDate) => { // Calcularmos la edad del trabajador
    const today = moment();
    const nextBirthday = moment(birthDate).year(today.year());

    if (today.isAfter(nextBirthday) || today.isSame(nextBirthday, "day")) {
      nextBirthday.add(1, "year");
    }

    const age = nextBirthday.diff(moment(birthDate), "years");
    return age;
  };

  const promAgeWorkers = birthdayWorkers.reduce((total, worker) => total + (calculateAge(worker.birthday) - 1), 0 ) / birthdayWorkers.length;

  const handleCheckboxChange = async (serviceId, checked) => {
    try {
      await HandleUpdateCheckbox("statusReadByAdmin", checked, serviceId, "serviciosCotizaciones");
      // Actualizar el estado local
      setPendingPaymentServices(prevServices => 
        prevServices.map(service => 
          service.id === serviceId 
            ? { ...service, statusReadByAdmin: checked }
            : service
        )
      );
      
      // Actualizar el estado global de notificaciones
      if (checked) {
        dispatch(decrementNotifications());
      } else {
        dispatch(incrementNotifications());
      }
    } catch (error) {
      return false
    }
  };

  return (
    <div className="h-screen w-full">

      <DrawerCotizacionCalendarioPagosDetails
        open={openDrawer}
        dataDrawer={activeCotizacionData}
        onClose={() => setOpenDrawer(false)}
        isAdmin={isAdmin}
        paises={paises}
        currencyExchanges={currencyExchanges}
      />

      <Modal
        activeModal={openModal}
        onClose={() => {
          setOpenModal(false)
          setServiceData(null)
        }}
        title="Comentarios área operativa"
        centered
      >
        <div className="flex flex-col gap-2">

          <div className="text-xs text-gray-800 font-semibold text-lg">
            <span className="font-bold">Cliente: </span>
            <span className="font-light">{serviceData?.cotizacion?.cliente?.nombreComercial}</span>
          </div>

          <div className="text-xs text-gray-800 font-semibold text-lg">
            <span className="font-bold">Servicio: </span>
            <span className="font-light">{serviceData?.servicio?.name}</span>
          </div>

          <h3 className="text-xs font-bold text-gray-700 mt-3">Comentarios:</h3>
          {/* Sección de comentarios */}
          <div className="max-h-[300px] overflow-y-auto">
            {serviceData?.comentariosOperativa?.map((comment, index) => (
              <div key={index} className="mb-2 px-4 py-2 rounded-lg border border-gray-200 shadow-sm bg-white">

                <div className="flex flex-row justify-between items-center space-x-3 mb-2">
                  <div className="flex flex-row gap-2 items-center justify-center">
                    <img
                      src={comment?.usuario?.foto?.url || user?.foto?.url}
                      alt={comment?.usuario?.nombre || user.nombre}
                      className="w-8 h-8 rounded-full object-cover"
                    />
                    <span className="text-xs font-semibold text-gray-800">{comment?.usuario?.name || user.name}</span>
                  </div>
                  <div className="text-xs text-gray-500">{new Date(comment.fecha).toLocaleString()}</div>
                </div>

                <div className="text-gray-700 text-xs border bordar-gray-200 rounded-md px-2 py-1">{comment.comentario}</div>
              </div>
            ))}
          </div>
        </div>
      </Modal>

      <div className="w-full flex flex-col md:flex-row px-8 pt-8 gap-4 h-screen">

          {/* Sección Izquierda */}
          <div className="w-full md:w-3/4 flex flex-col gap-4">

            {/* Bienvenido */}
            <div className="flex items-center justify-start text-xl lg:text-2xl xl:text-3xl">
              <b className="flex-1 relative">
                <span>{user.sexo === "femenino" ? "Bienvenida " : "Bienvenido "}</span>                
                <span className="text-[#ff6400]">{user.name}</span>
                <span className="ml-2 text-4xl">🙂</span>
              </b>
            </div>

            {/* Tabla proyectos pendientes de cobro admin */}
            {isAdmin ? (
              <>                
                <div className="flex flex-row gap-2 items-center justify-start">
                  <h2 className="text-xs font-bold">Proyectos finalizados pendientes de cobro</h2>
                  <GiReceiveMoney />
                </div>

                <div className="flex flex-grow items-start justify-start overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
                  {loading ? (
                    <LoadingScreen />
                  ) : pendingPaymentServices.length === 0 ? (
                    <NoDataScreen />
                  ) : (
                    <table className="w-full shadow-lg rounded-lg">
                      <thead className="bg-white sticky top-0">
                        <tr className="text-gray-700 text-center text-[10px] font-bold">
                          <th className="px-1 py-1 text-center bg-[#FE6400] border-r border-r-white text-white border border-gray-300">
                            Leído
                          </th>
                          <th className="px-1 py-1 text-center bg-[#FE6400] border-r border-r-white text-white border border-gray-300">
                            Cotización
                          </th>
                          <th className="px-1 py-1 text-center bg-[#FE6400] border-r border-r-white text-white border border-gray-300">
                            Estado pago
                          </th>
                          <th className="px-1 py-1 text-center bg-[#FE6400] border-r border-r-white text-white border border-gray-300">
                            Cliente
                          </th>
                          <th className="px-1 py-1 text-center bg-[#FE6400] border-r border-r-white text-white border border-gray-300">
                            Servicio
                          </th>
                          <th className="px-1 py-1 text-center bg-[#FE6400] border-r border-r-white text-white border border-gray-300">
                            Encargado
                          </th>
                          <th className="px-1 py-1 text-center bg-[#FE6400] border-r border-r-white text-white border border-gray-300">
                            % proyecto
                          </th>
                          <th className="px-1 py-1 text-center bg-[#FE6400] border-r border-r-white text-white border border-gray-300">
                            Info enviada
                          </th>
                          {/* <th className="px-1 py-1 text-center bg-[#FE6400] border-r border-r-white text-white border border-gray-300">
                            Link desarrollo
                          </th> */}
                          <th className="px-1 py-1 text-center bg-[#FE6400] border-r border-r-white text-white border border-gray-300">
                            Duracion real
                          </th>
                          <th className="px-1 py-1 text-center bg-[#FE6400] border-r border-r-white text-white border border-gray-300">
                            Comentarios op.
                          </th>
                          <th className="px-1 py-1 text-center bg-[#FE6400] border-r border-r-white text-white border border-gray-300">
                            Comentario actu.
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {pendingPaymentServices.map((service) => {
                          const duracionReal = service.fechaInfoCompleta ? (
                            service.estado === "En proceso"
                              ? Math.ceil((new Date().getTime() - new Date(service.fechaInfoCompleta).getTime()) / (1000 * 60 * 60 * 24))
                              : service.estado === "Terminado con exito" && service.fechaEntrega
                              ? Math.ceil((new Date(service.fechaEntrega).getTime() - new Date(service.fechaInfoCompleta).getTime()) / (1000 * 60 * 60 * 24))
                              : "N/A"
                          ) : "N/A"
                          return (
                          <tr key={service.id} className={`text-[10px] w-full hover:bg-gray-100 transition-all duration-100 rounded-lg` } >
                            <td scope="row" className="px-1 py-2 text-center border border-gray-300">
                              <input
                                type="checkbox"
                                className="rounded-md border-gray-400 hover:cursor-pointer"
                                checked={service.statusReadByAdmin}
                                onChange={(e) => handleCheckboxChange(service.id, e.target.checked)}
                              />
                            </td>
                            <td scope="row" className="px-1 py-2 text-center border border-gray-300">
                              <div className="flex items-center justify-center">
                                <DetailsButton action={() => {
                                    setActiveCotizacionData(service.cotizacion)
                                    setOpenDrawer(true)
                                  }} 
                                  content="Ver cotización" 
                                />
                              </div>
                            </td>
                            <td scope="row" className={`px-1 py-2 text-center border font-bold border-gray-300 ${service.facturacion === "Deuda" ? "text-red-500" : "text-green-500"}`}>
                              {service.facturacion}
                            </td>
                            <td scope="row" className="px-1 py-2 text-center border border-gray-300">
                              <a 
                                href={`/home/seguimiento/${service.cotizacion?.cliente?.id}`} 
                                className="hover:underline"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {service.cotizacion?.cliente?.nombreComercial}
                              </a>
                            </td>
                            <td scope="row" className="px-1 py-2 text-center border border-gray-300">
                              <a 
                                href={`/home/seguimiento/${service.cotizacion?.cliente?.id}/${service.servicio?.name}/${service.id}`}
                                className="hover:underline"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {service.servicio?.name}
                              </a>
                            </td>
                            <td scope="row" className="px-1 py-2 text-center border border-gray-300">
                              {service.responsable?.name}
                            </td>
                            <td scope="row" className="px-1 py-2 text-center border border-gray-300">
                              {service.porcentajeAvance}%
                            </td>
                            <td scope="row" className="px-1 py-2 text-center border border-gray-300">
                              <div className={`flex flex-row items-center font-bold justify-center gap-1 ${infoEnviada[service.informacionEnviada]}`}>
                                {service.informacionEnviada}
                              </div>
                            </td>
                            {/* <td scope="row" className="px-1 py-2 text-center border border-gray-300">
                              <div className="flex flex-row items-center justify-center gap-1">
                                {service?.links?.find((l) => l.titulo === "Link demo")?.url ? (
                                    <a 
                                      href={service.links.find((l) => l.titulo === "Link demo").url}
                                      target="_blank" 
                                      rel="noreferrer"
                                      className="flex items-center gap-2 hover:cursor-pointer hover:underline transition-all duration-100"
                                    >
                                      <span>Link</span>
                                      <FaExternalLinkAlt className="text-blue-500" />
                                    </a>
                                  ):( 
                                    <FaEyeSlash />
                                  )
                                }
                              </div>
                            </td> */}
                            <td scope="row" className={`px-1 py-2 text-center border border-gray-300 ${duracionReal === "N/A" ? "text-gray-200" : "text-gray-600"}`}>
                              {duracionReal}
                            </td>
                            <td scope="row" className="px-1 py-2 text-center border border-gray-300">
                              <div className="flex flex-row justify-center items-center gap-2">
                                <DetailsButton action={() => {
                                    setServiceData(service)
                                    setOpenModal(true)
                                  }} 
                                  content="Ver comentarios" 
                                />
                              </div>
                            </td>
                            <td scope="row" className="px-1 py-2 text-center border border-gray-300">
                              {service?.comentariosOperativa?.length > 0 ? (
                                <div className="text-[10px] text-gray-600">
                                  {new Date(service.comentariosOperativa[service.comentariosOperativa.length - 1].fecha).toLocaleDateString()}
                                </div>
                              ) : (
                                <div className="text-[10px] text-gray-200">-</div>
                              )}
                            </td>
                          </tr>
                        )})}
                      </tbody>
                    </table>
                  )}
                </div>

                {/* <PaginationItem
                  actualDocs={pendingPaymentServices.length}
                  totalDocs={totalDocs}
                  entity="proyectos"
                  totalPages={totalPages}
                  actualPage={page}
                  handlePageChange={handlePageChange}
                /> */}
              </>
            ) : (
              <>
                <div className="flex w-full flex-col justify-center items-start p-3 bg-white rounded-lg border border-gray-200 shadow">
                  <h2 className="text-md mb-4 font-bold">
                    Notas de Administradores
                  </h2>
                  <div className="p-4 w-full">

                    <AnunciosHomeContainer anuncios={anuncios}/>
                    
                  </div>
                </div>

                <div className="self-stretch flex flex-col items-start justify-center">
                  <div className="self-stretch flex flex-col p-2.5 box-border items-start justify-center">
                    <div className="self-stretch relative font-bold mb-4">
                      Herramientas
                    </div>
                  </div>
                  <div className="self-stretch flex flex-row flex-wrap items-center justify-start gap-[40px] text-lg text-white">
                    <Link
                      className="rounded-2xl bg-zinc-800 box-border w-[335px] h-[109px] flex flex-row p-5 items-center justify-start gap-[15px] border-[1px] border-solid border-gris"
                      to="/home/marcar-asistencia"
                    >
                      <div className="rounded-full bg-[#ff6400] shadow-[0px_4px_4px_rgba(0,_0,_0,_0.25)] w-[45px] h-[45px] flex flex-row p-2.5 box-border items-center justify-center">
                        <FaCalendarAlt className="relative w-[21px] h-[18px]" />
                      </div>
                      <div className="flex-1 flex flex-row p-2.5 items-center justify-start">
                        <div className="flex-1 relative font-semibold">
                          Control de Asistencia
                        </div>
                      </div>
                      <div className="flex flex-col p-2.5 items-center justify-start">
                        <FaRegStar className="relative w-5 h-[19px]" />
                      </div>
                    </Link>
                    <Link
                      className="rounded-2xl bg-zinc-800 box-border w-[335px] h-[109px] flex flex-row p-5 items-center justify-start gap-[15px] border-[1px] border-solid border-gris"
                      to="/home/tareas"
                    >
                      <div className="rounded-full bg-[#ff6400] shadow-[0px_4px_4px_rgba(0,_0,_0,_0.25)] w-[45px] h-[45px] flex flex-row p-2.5 box-border items-center justify-center">
                        <FaPenSquare className="relative w-[18px] h-5" />
                      </div>
                      <div className="flex-1 flex flex-row p-2.5 items-center justify-start">
                        <div className="flex-1 relative font-semibold">
                          Registro de Tareas
                        </div>
                      </div>
                      <div className="flex flex-col p-2.5 items-center justify-start">
                        <FaRegStar className="relative w-5 h-[19px]" />
                      </div>
                    </Link>
                  </div>
                </div>

                <div className="self-stretch flex flex-col items-start justify-center">
                  <div className="self-stretch flex flex-col p-2.5 items-start justify-center">
                    <div className="self-stretch relative font-semibold mb-4">
                      Modulos de la agencia
                    </div>
                  </div>
                  <div className="self-stretch flex flex-row flex-wrap items-center justify-start gap-[40px] text-lg text-white">
                    <Link
                      className="rounded-2xl bg-zinc-800 box-border w-[210px] h-[200px] flex flex-col py-[25px] px-[15px] items-start justify-center gap-[8px] cursor-pointer border-[1px] border-solid border-gris"
                      to="/home/recursos"
                    >
                      <div className="flex flex-row items-center justify-start gap-[95px]">
                        <div className="rounded-full bg-[#ff6400] shadow-[0px_4px_4px_rgba(0,_0,_0,_0.25)] w-[45px] h-[45px] flex flex-row p-2.5 box-border items-center justify-center">
                          <FaFolderOpen className="relative w-[19.5px] h-[19.5px]" />
                        </div>
                        <div className="flex flex-col p-2.5 items-center justify-start">
                          <FaRegStar className="relative w-5 h-[19px]" />
                        </div>
                      </div>
                      <div className="self-stretch flex flex-row p-2.5 items-center justify-start">
                        <div className="relative font-semibold inline-block w-[132px] shrink-0">
                          Módulo de Recursos
                        </div>
                      </div>
                    </Link>
                    <Link
                      className="rounded-2xl bg-zinc-800 box-border w-[210px] h-[200px] flex flex-col py-[25px] px-[15px] items-start justify-center gap-[8px] cursor-pointer border-[1px] border-solid border-gris"
                      to="/home/proyectos"
                    >
                      <div className="flex flex-row items-center justify-start gap-[95px]">
                        <div className="rounded-full bg-[#ff6400] shadow-[0px_4px_4px_rgba(0,_0,_0,_0.25)] w-[45px] h-[45px] flex flex-row p-2.5 box-border items-center justify-center">
                          <FaBriefcase className="relative w-[19.5px] h-[19.5px]" />
                        </div>
                        <div className="flex flex-col p-2.5 items-center justify-start">
                          <FaRegStar className="relative w-5 h-[19px]" />
                        </div>
                      </div>
                      <div className="self-stretch flex flex-row p-2.5 items-center justify-start">
                        <div className="relative font-semibold inline-block w-[132px] shrink-0">
                          Módulo de Proyectos
                        </div>
                      </div>
                    </Link>
                    <Link
                      className="rounded-2xl bg-zinc-800 box-border w-[210px] h-[200px] flex flex-col py-[25px] px-[15px] items-start justify-center gap-[8px] cursor-pointer border-[1px] border-solid border-gris"
                      to="/home/ventas"
                    >
                      <div className="flex flex-row items-center justify-start gap-[95px]">
                        <div className="rounded-full bg-[#ff6400] shadow-[0px_4px_4px_rgba(0,_0,_0,_0.25)] w-[45px] h-[45px] flex flex-row p-2.5 box-border items-center justify-center">
                          <FaMoneyBill className="relative w-[18px] h-[22px]" />
                        </div>
                        <div className="flex flex-col p-2.5 items-center justify-start">
                          <FaRegStar className="relative w-5 h-[19px]" />
                        </div>
                      </div>
                      <div className="self-stretch flex flex-row p-2.5 items-center justify-start">
                        <div className="relative font-semibold inline-block w-[132px] shrink-0">
                          Módulo de Ventas
                        </div>
                      </div>
                    </Link>
                    <Link
                      className="rounded-2xl bg-zinc-800 box-border w-[210px] h-[200px] flex flex-col py-[25px] px-[15px] items-start justify-center gap-[8px] cursor-pointer border-[1px] border-solid border-gris"
                      to="/home/clientes"
                    >
                      <div className="flex flex-row items-center justify-start gap-[95px]">
                        <div className="rounded-full bg-[#ff6400] shadow-[0px_4px_4px_rgba(0,_0,_0,_0.25)] w-[45px] h-[45px] flex flex-row p-2.5 box-border items-center justify-center">
                          <FaHandshake className="relative w-5 h-3.5" />
                        </div>
                        <div className="flex flex-col p-2.5 items-center justify-start">
                          <FaRegStar className="relative w-5 h-[19px]" />
                        </div>
                      </div>
                      <div className="w-[132px] flex flex-row p-2.5 box-border items-center justify-start">
                        <div className="flex-1 relative font-semibold">{`Módulo de Clientes `}</div>
                      </div>
                    </Link>
                    <Link
                      className="rounded-2xl bg-zinc-800 box-border w-[210px] h-[200px] flex flex-col py-[25px] px-[15px] items-start justify-center gap-[8px] cursor-pointer border-[1px] border-solid border-gris"
                      to="/home/rrhh"
                    >
                      <div className="flex flex-row items-center justify-start gap-[95px]">
                        <div className="rounded-full bg-[#ff6400] shadow-[0px_4px_4px_rgba(0,_0,_0,_0.25)] w-[45px] h-[45px] flex flex-row p-2.5 box-border items-center justify-center">
                          <FaBuilding className="relative w-5 h-[18px]" />
                        </div>
                        <div className="flex flex-col p-2.5 items-center justify-start">
                          <FaRegStar className="relative w-5 h-[19px]" />
                        </div>
                      </div>
                      <div className="self-stretch flex flex-row p-2.5 items-center justify-start">
                        <div className="flex-1 relative font-semibold">
                          <p className="m-0">Módulo de</p>
                          <p className="m-0">{`RR.HH. `}</p>
                        </div>
                      </div>
                    </Link>
                    <Link
                      className="rounded-2xl bg-zinc-800 box-border w-[210px] h-[200px] flex flex-col py-[25px] px-[15px] items-start justify-center gap-[8px] cursor-pointer border-[1px] border-solid border-gris"
                      to="/home/learning"
                    >
                      <div className="flex flex-row items-center justify-start gap-[95px]">
                        <div className="rounded-full bg-[#ff6400] shadow-[0px_4px_4px_rgba(0,_0,_0,_0.25)] w-[45px] h-[45px] flex flex-row p-2.5 box-border items-center justify-center">
                          <FaChalkboardTeacher className="relative w-[22px] h-[18px]" />
                        </div>
                        <div className="flex flex-col p-2.5 items-center justify-start">
                          <FaRegStar className="relative w-5 h-[19px]" />
                        </div>
                      </div>
                      <div className="self-stretch flex flex-row p-2.5 items-center justify-start">
                        <div className="flex-1 relative font-semibold">{`Módulo de Learning `}</div>
                      </div>
                    </Link>
                    <Link
                      className="rounded-2xl bg-zinc-800 box-border w-[210px] h-[200px] flex flex-col py-[25px] px-[15px] items-start justify-center gap-[8px] cursor-pointer border-[1px] border-solid border-gris"
                      to="/home/contabilidad"
                    >
                      <div className="flex flex-row items-center justify-start gap-[95px]">
                        <div className="rounded-full bg-[#ff6400] shadow-[0px_4px_4px_rgba(0,_0,_0,_0.25)] w-[45px] h-[45px] flex flex-row p-2.5 box-border items-center justify-center">
                          <FaCalculator className="relative w-[19px] h-5" />
                        </div>
                        <div className="flex flex-col p-2.5 items-center justify-start">
                          <FaRegStar className="relative w-5 h-[19px]" />
                        </div>
                      </div>
                      <div className="self-stretch flex flex-row p-2.5 items-center justify-start">
                        <div className="flex-1 relative font-semibold">{`Módulo de Contabilidad `}</div>
                      </div>
                    </Link>
                    <Link
                      className="rounded-2xl bg-zinc-800 box-border w-[210px] h-[200px] flex flex-col py-[25px] px-[15px] items-start justify-center gap-[8px] cursor-pointer border-[1px] border-solid border-gris"
                      to="/home/tutoriales"
                    >
                      <div className="flex flex-row items-center justify-start gap-[95px]">
                        <div className="rounded-full bg-[#ff6400] shadow-[0px_4px_4px_rgba(0,_0,_0,_0.25)] w-[45px] h-[45px] flex flex-row p-2.5 box-border items-center justify-center">
                          <FaPhotoVideo className="relative w-[19px] h-5" />
                        </div>
                        <div className="flex flex-col p-2.5 items-center justify-start">
                          <FaRegStar className="relative w-5 h-[19px]" />
                        </div>
                      </div>
                      <div className="self-stretch flex flex-row p-2.5 items-center justify-start">
                        <div className="flex-1 relative font-semibold">{`Módulo de Tutoriales `}</div>
                      </div>
                    </Link>
                  </div>
                </div>
              </>
            )}
          </div>

          {/* Sección Derecha */}
          <div className="w-full md:w-1/4 flex flex-col gap-4 pt-14">
            {/* Buscador de Clientes */}
            {/* {user.area === "Comercial" && (
              <div className="flex flex-col bg-white mx-2 mb-6 p-4 items-start justify-start rounded-lg">
                <Link
                  to={"/home/buscador-clientes"}
                  className="hidden lg:flex w-max py-2 px-4 justify-start items-center rounded-md text-white bg-[#ff6400] overflow-hidden"
                >
                  <h2 className="font-bold text-lg text-center mr-4">
                    Buscador de clientes
                  </h2>
                  <FaAddressCard className="h-5 w-5" />
                </Link>
              </div>
            )} */}
            
            {/* Favoritos */}
            {/* <div className="flex flex-col p-4 items-start justify-start rounded-lg border border-gray-200 shadow">
              <div className="flex flex-row gap-2 items-center justify-center ">
                <h2 className="text-lg font-bold">Favoritos </h2>
                <FaStar  />
              </div>
            </div> */}

            {/* Equipo - Cumpleaños */}
            <div className="flex flex-row gap-2 items-center justify-start ">
              <h2 className="text-xs font-bold">Equipo<span className="font-light text-[10px]"> ~ prom {promAgeWorkers.toFixed(2)} años</span></h2>
              <MdGroups  />
            </div>

            <div className="flex flex-col p-2 items-start justify-start rounded-lg border border-gray-200 shadow">
              <div className="w-full">
                <p className="text-[10px] font-semibold mb-4">
                  Próximos cumpleaños:
                </p>
                <div className="w-full flex flex-col gap-2">
                  {birthdayWorkers.slice(0, 5).map((worker, index) => (
                    <div
                      key={worker.id}
                      className="w-full text-[10px] gap-4 p-2 border border-gray-200 rounded-lg shadow"
                    >
                      <div className="flex flex-row gap-2 items-center">
                        <FaBirthdayCake className={`text-xs ${index === 0 ? "text-[#ff6400]" : ""}`}/>
                        <div className="flex flex-col">
                          <p className="text-[10px]">
                            {worker.name}:{" "}
                            <span className="font-semibold">
                              {moment.utc(worker.birthday).format("DD/MM")} -{" "}
                              {calculateAge(worker.birthday)} años
                            </span>
                          </p>
                          <span className="text-[10px] font-light">
                            faltan {worker.daysUntilBirthday} días
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Fechas Importantes */}
            <div className="flex flex-col p-2 items-start justify-start rounded-lg border border-gray-200">
              <h2 className="text-[10px] font-bold mb-2">Fechas Importantes</h2>
              <div className="w-full">
                <button className="text-[10px] font-semibold py-2 px-3 bg-[#ff6400] text-white rounded-lg mr-2">
                  Feriados
                </button>
                <button className="text-[10px] font-semibold py-2 px-3 border border-zinc-200 text-zinc-500 rounded-lg">
                  Eventos
                </button>
              </div>
            </div>

            <div  className="bg-white rounded-md">
              <a href="/images/ORGANIGRAMA MC.png" target="_blank">
                <img alt="organigrama" className=" w-full h-auto rounded-lg" src="/images/ORGANIGRAMA MC.png"/>
              </a>
            </div>

          </div>
      </div>
    </div>
  );
};

export default Inicio;
